module.exports = __webpack_public_path__ + "img/icon-extend.83f33fc8.png";